export default {"src":"/_next/static/media/location_pin_64.3b3a71ab.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};